<template>
  <div class="chat">
    <a-spin class="loading" v-show="chatLoading" tip="消息加载中..."/>
    <div class="group-title">
      <span>{{ group.groupName || group.className }}</span>
<!--      <span v-show="isStudentJoin==1" class="tooltips" @click="lookApply">-->
<!--        <a-icon type="sound"/>-->
<!--        <span class="joinClass">有同学想加入班级</span>-->
<!--      </span>-->
    </div>
    <div class="messages" >
      <div class="load-more" v-if="pageNum<totalPages"
           @click="getHistoryMsg (groupid,msgRecordType,pageNum+1)">
        加载更多
      </div>
      <div v-for="message in groupMessages" :key="message.id" :data-id="message.id"
           :class="{message:true,right:message.from === userId}" ref="message">
        <img v-if="message.from !== userId" :src="getUserPhoto(message)" class="user-photo"/>
        <div class="message-body">
          <div class="user-name">{{ message.fromName }}{{ message.fromUserName }}</div>
          <div v-if="(message.type==='txt'||message.msgType==='txt')&&message.msg" class="message-content"
               v-html="renderTxt(message.msg)"></div>
          <div v-else-if="message.type==='img'||message.msgType==='img'" class="cursor-pointer">
            <img :src="(message.url).startsWith('http')?message.url:resBasePath + message.url" @click='preview(message)'
                 style="width:300px;border-radius:5px;"/>
          </div>
          <div v-else-if="message.type==='audio'||message.msgType==='audio'" class="message-content">
            <audio id="my-audio" ref="myAudio"
                   :src="(message.url).startsWith('http')?message.url:resBasePath + message.url" controls></audio>
          </div>
          <div v-else-if="message.type==='video'||message.msgType==='video'" class="message-content">
            <video :src="(message.url).startsWith('http')?message.url:resBasePath + message.url" width="300px"
                   controls></video>
          </div>
          <a-card style="width: 300px" title="文件"
                  v-else-if="(message.type==='file'||message.msgType==='file') && message.url"
                  class="message-content">
            <div slot="extra" class="flex-row align-center">
              <a-button @click="preview(message)" type="link" block>
                预览
              </a-button>
              <a style="width:100%" :href="(message.url).startsWith('http')?message.url:resBasePath + message.url"
                 :download="message.filename">下载</a>
            </div>
            <p style="word-break: break-word">{{ message.filename }}</p>
            <p v-if="message.fileLength">{{ getFileSize(message.fileLength) }}</p>
            <p v-else-if="message.file_length">{{ getFileSize(message.file_length) }}</p>
          </a-card>
          <a-card v-else title="文件" style="width: 300px">
            <div slot="extra" class="flex-row align-center">
              <!-- <a-button @click="withdraw(message)" type="link" block>
                撤销
              </a-button> -->
              <a style="width:100%" :href="resBasePath + message.url" :download="message.filename">下载</a>
            </div>
            <p>{{ message.filename }}</p>
            <p>{{ getFileSize(message.fileLength) }}</p>
          </a-card>
          <div class="message-time" v-if="message.createDate">{{ format.format(Number(message.createDate)) }}</div>
          <div class="message-time" v-else-if="message.time">{{ format.format(Number(message.time)) }}</div>
        </div>
        <img v-if="message.from === userId"
             :src="userPhoto&&userPhoto!=null?$userINfoBasePath +'/'+ userPhoto: mrImg" class="user-photo"/>
      </div>
    </div>
    <div class="sent">
      <div>
        <a-dropdown :trigger="['click']" placement="topLeft">
          <a-icon class="msg-type-btn" type="smile"/>
          <a-menu slot="overlay">
            <a-menu-item v-for="(emoji,index) in emojiList" :key="index" @click="selectEmoji(index)"><img
                :src="`faces/${emoji}`"/></a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-icon @click="clickUpload()" class="msg-type-btn" type="folder-open"/>
        <!-- <a-icon @click="openRecorder()" class="msg-type-btn" type="audio" /> -->
      </div>
      <div class="sent-content">
        <a-input v-model="msgText" equired placeholder="输入消息" class="sengTxt" @pressEnter="sendTextMsg"
                 style="resize:none" ref="txtDom"/>
        <input @change="fileChange" type="file" multiple style="display:none" ref="uploadDom"/>
        <a-button @click="sendTextMsg" :disabled="msgText===''">发送</a-button>
      </div>
    </div>
    <a-modal v-model="recoderVisible" width="0" centered :title="null" :closable="false" :footer="null">
      <div class="recoder">
        <div class="sound-waves">
          <div v-for="(iheight, index) in randomheight" class="wavesItem" :key="index"
               :style="{'height': iheight + 'px'}"></div>
        </div>
        <div class="remainingRecTime">{{ remainingRecTime }} 秒</div>
        <div class="tipText">按住开始录音</div>
        <a-button type="primary" class="holdBtn" @touchstart="mouseStart" @touchend="mouseEnd"
                  @mousedown.prevent="mouseStart" @mouseup.prevent="mouseEnd">
          <a-icon type="audio" style="font-size: 24px"></a-icon>
        </a-button>
      </div>
    </a-modal>
<!--    <a-modal title="" :visible="applyVisible" footer="" @cancel="handleCancel">-->
<!--      <ul>-->
<!--        <li class="applyLi" v-for="(item,index) in applyList" :key="index">-->
<!--          <div class="applyName">-->
<!--            <img class="userImg" :src="item.photo&&item.photo!=null?$userINfoBasePath+'/'+item.photo: mrImg"-->
<!--                 alt=""/>-->
<!--            <span class="userName">{{ item.userName }}</span>-->
<!--            <span class="name">请求加入</span>-->
<!--            <span class="className">{{ item.className }}</span>-->
<!--          </div>-->
<!--          <div class="applyFun">-->
<!--            <a-button v-if="item.isPermit === 0" class="sure" type="primary"-->
<!--                      @click="sureFun(item)">同意-->
<!--            </a-button>-->
<!--            <a-button v-if="item.isPermit === 0" class="refuse" type="danger"-->
<!--                      @click="refuseFun(item)">拒绝-->
<!--            </a-button>-->
<!--            <a-button v-if="item.isPermit === 1" class="sure" type="primary">已同意</a-button>-->
<!--            <a-button v-if="item.isPermit === 2" class="sure" type="primary">已拒绝</a-button>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </a-modal>-->
    <file-preview :visible.sync="previewVisible" v-if="previewVisible" :file="previewFile"></file-preview>

  </div>
</template>

<script>
import WebIM from 'utils/WebIM'
import shareState from 'utils/shareState.js'
import format from 'utils/format.js'
import emoji from 'utils/emoji.js'
import { getFileType, getFileSize } from 'utils/getFileInfo.js'
import Recorder from 'js-audio-recorder'
import FilePreview from 'components/FilePreview'
import axios from 'axios'

export default {
  name: 'ChatClass',
  components: {
    FilePreview
  },
  props: {
    type: '' // group-小组聊天 group-班级聊天
  },
  data () {
    return {
      mrImg: require('../../assets/imgs/student.png'),
      resBasePath: this.$resBasePath + '/',
      shareData: shareState.state,
      format,
      getFileType,
      getFileSize,
      groupid: '',
      msgText: '',
      msgType: 'txt',
      userName: '',
      userId: '',
      userPhoto: '',
      emojiList: emoji.obj,
      previewVisible: false,
      previewFile: { name: '', url: '' },
      recoderVisible: false,
      randomheight: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      recorder: null,
      recConfig: {
        sampleBits: 16,
        sampleRate: 11025,
        numChannels: 1
      },
      isRecording: false,
      totalRecTime: 60,
      remainingRecTime: 60,
      // applyList: [],
      // applyVisible: false,
      // isStudentJoin: '', // 是否有学生加入
      // applyParam: null, // 学生加入班级同意或者拒绝参数
      access_token: '',
      pageNum: 1,
      // 按照要求修改为100
      pageSize: 500,
      totalPages: 1,
      msgRecordType: 1,
      timestamp: new Date().getTime(),
      chatLoading: false
    }
  },
  watch: {
    $route () {
      this.groupid = this.$route.params.groupid
    },
    groupMessages (val) {
      this.scrollTo()
      console.log(val)
      if (val[val.length - 1].msgType === 'audio') {
        console.log('语音消息刷新')
        // 最新的一条消息是语音，就刷新列表
        // this.getHistoryByType(false, val[val.length - 1])
        // 监听<audio>标签的加载状态
        // this.playAudio()
      }
    },
    groupid () {
      // console.log(this.type)
      //  console.log(this.$route)
      //  console.log(this.groupid)
      this.getHistoryByType(true, null)
    }

  },
  mounted () {
    // this.chatLoading = true;
    this.groupid = this.$route.params.groupid
    this.userName = this.$store.state.userInfo.name
    this.userId = this.$store.state.userInfo.id
    // this.userPhoto = this.shareData.userPhoto
    this.userPhoto = this.$store.state.userInfo.photo
    this.scrollTo()
    if (this.type === 'class') {
      // this.isStudentJoin = this.shareData.isStudentJoin
      // if (this.isStudentJoin == 1) {
      //   this.getStudentsApply()
      // }
      // 一进入页面就查询是否有加班申请
      // this.getClassInfoById()
    }

    // 后续统一到this.$store中
    if (this.access_token == null || this.access_token === '') {
      this.access_token = localStorage.getItem('access_token')
    }
  },
  computed: {
    groupMessages () {
      // 从消息记录中获取本群组的消
      const messages = this.shareData.msgList.filter((msg) => msg.to === this.groupid)
      // console.log(messages)
      return messages || []
    },
    group () {
      // 从群组记录中获取当前群组
      const groupid = this.groupid
      const group = this.shareData.imGroupList?.find((g) => g.groupTag === groupid)
      return group || {}
    }
  },
  methods: {
    getHistoryByType (isRefreshHistoryMsg, message) {
      this.timestamp = new Date().getTime()
      // if (this.groupMessages.length < 20) {
      if (this.type === 'class') {
        // 班级
        this.msgRecordType = 1
        if (isRefreshHistoryMsg) {
          // 获取历史列表
          this.getHistoryMsg(localStorage.getItem('classID'), this.msgRecordType, this.pageNum, false)
        } else {
          // 刷新语音消息
          this.refreshAudioMsg(localStorage.getItem('classID'), this.msgRecordType, this.pageNum, false, message)
        }
      } else {
        // 小组
        this.msgRecordType = 2
        const groupLists = this.$store.state.groupLists
        // 获取小组id
        const group = groupLists.filter(g => g.groupTag === this.groupid)[0]
        // console.log(group.id)
        // console.log(this.groupid)
        if (isRefreshHistoryMsg) {
          // 获取历史列表
          this.getHistoryMsg(group.id, this.msgRecordType, this.pageNum, false)
        } else {
          // 刷新语音消息
          this.refreshAudioMsg(localStorage.getItem('classID'), this.msgRecordType, this.pageNum, false, message)
        }
      }
    },
    getHistoryMsg (targetId, msgRecordType, pageNum, scrollTop = true) {
      const _this = this
      _this.chatLoading = true
      // 按照要求pageNum传固定值 “1”
      this.pageNum = 1
      this.$fetch({
        url: this.$httpConfig.pageClassGroupChatMsgHistoryList,
        body: {
          targetId,
          msgRecordType,
          timestamp: this.timestamp,
          pageSize: this.pageSize,
          pageNum
        }
      })
        .done((res) => {
          console.log(res)
          _this.chatLoading = false
          if (!res.success) return
          this.totalPages = res.resultData.pages
          const msg = res.resultData.list.map((m) => {
            m.file = {
              size: m.fileLength,
              name: m.filename,
              url: m.url || ''
            }
            m.ext = {
              avatar: m.fromPhoto,
              nikeName: m.fromName
            }
            m.msgType = m.type
            return m
          })
          shareState.setMsgList(msg, scrollTop)
          _this.$forceUpdate();
          // 记录最后一条消息时间戳，下次调用接口使用
          if (res.resultData.list != null && res.resultData.list.length > 1) {
            this.timestamp = res.resultData.list[res.resultData.list.length - 1].createDate
          }
        })
    },
    refreshAudioMsg (targetId, msgRecordType, pageNum, scrollTop = true, message) {
      // 按照要求pageNum传固定值 “1”
      // this.pageNum = 1
      // const _this = this
      // this.$fetch({
      //   url: this.$httpConfig.pageClassGroupChatMsgHistoryList,
      //   body: {
      //     targetId,
      //     msgRecordType,
      //     timestamp: new Date().getTime(),
      //     pageSize: 1,
      //     pageNum
      //   }
      // })
      //   .loading(
      //     () => (this.loading = true),
      //     () => (this.loading = false)
      //   )
      //   .done((res) => {
      //     console.log(res)
      //     if (!res.success) return
      //     // const chatMsg = res.resultData.list.filter(msg => msg.id === message.id)
      //     // this.$refs.message.re
      //     // console.log('message.id', message.id)
      //     // const audio = document.getElementById(message.id)
      //     // console.log('audio', audio)
      //     // audio.src = this.resBasePath + chatMsg.file.url
      //     // console.log('url', this.resBasePath + chatMsg.url)
      //
      //     const msg = res.resultData.list[0]
      //     console.log('msg', msg)
      //     // shareState.setMsgList(msg, scrollTop)
      //     _this.$refs.messag.re()
      //   })
    },
    saveMsg (msg) {
      const param = {
        msgRecordType: this.type === 'class' ? 1 : 2,
        targetId: this.type === 'class' ? localStorage.getItem('classID') : this.groupid,
        ...msg
      }
      this.$fetch({
        url: this.$httpConfig.saveClassGroupChatMsgHistory,
        body: param
      }).done((res) => {
        // console.log(res);
      })
    },
    withdraw (message) {
      this.$fetch({
        url: this.$httpConfig.messageRetraction,
        body: { msgId: message.msgId }
      }).done((res) => {
        // console.log(res);
        if (res && res.success) {
        }
      })
    },
    getUserPhoto (message) {
      const reg = RegExp(/http/)
      if (message.ext?.avatar) {
        // 环信扩展消息带来的头像
        if (reg.test(message.ext?.avatar)) {
          return message.ext?.avatar
        } else {
          return this.$userINfoBasePath + '/' + message.ext?.avatar
        }
      } else if (message.fromPhoto) {
        // 本地服务器上传的头像
        if (reg.test(message.fromPhoto)) {
          return message.fromPhoto
        } else {
          return this.$userINfoBasePath + '/' + message.fromPhoto
        }
      } else {
        return this.mrImg
      }
    },
    // lookApply () {
    //  this.applyVisible = true
    // },
    // getStudentsApply () {
    //   // 获取学生加入班级列表
    //   const classMess = this.shareData.imGroupList?.find((g) => g.groupTag === this.groupid)
    //   this.$fetch({
    //     url: this.$baseUrl + 'ebook/group/common/getClassJoinApplyList',
    //     body: { classId: classMess.id }
    //   }).done((res) => {
    //     if (res && res.success && res.resultCode === 0) {
    //       this.applyList = res.resultData
    //     }
    //   })
    // },
    getClassInfoById () {
      // 查询班级是否有学生加入申请
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/getClassInfoById',
        body: { id: localStorage.getItem('classID') }
      })
        .loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        )
        .done((res) => {
          // console.log("数据完成2")
          if (res && res.success && res.resultCode === 0) {
            if (res.resultData.isStudentJoin === 1) {
              _this.isStudentJoin = 1
              _this.getStudentsApply()
            } else {
            }
          }
        })
    },
    // handleCancel () {
    //   // 加入班级弹窗
    //   this.applyVisible = false
    // },
    // sureFun (item) {
    //   // 同意加入班级
    //   this.applyParam = {
    //     studentId: item.userId,
    //     userId: this.$store.state.userInfo.id,
    //     classId: item.classId,
    //     isPermit: '1'
    //   }
    //   this.apply()
    // },
    // refuseFun (item) {
    //   // 拒绝加入班级
    //   this.applyParam = {
    //     studentId: item.userId,
    //     userId: this.$store.state.userInfo.id,
    //     classId: item.classId,
    //     isPermit: '2'
    //   }
    //   this.apply()
    // },
    // apply () {
    //   const _this = this
    //   _this
    //     .$fetch({
    //       url: _this.$baseUrl + 'ebook/group/common/setStudentsApplyClass',
    //       body: _this.applyParam
    //     })
    //     .done((res) => {
    //       if (res && res.success && res.resultCode === 0) {
    //         _this.getStudentsApply()
    //         _this.$message.success(res.resultMessage)
    //         _this.applyVisible = false
    //       }
    //     })
    // },
    preview (message) {
      // 图片消息放大预览
      // console.log(message);
      this.previewFile = {
        name: message.filename,
        url: (message.url).startsWith('http') ? message.url : this.resBasePath + message.url
      }
      this.previewVisible = true
    },
    scrollTo () {
      // 聊天记录区域滚动条滚动至最底部
      const msgdiv = this.$refs.message
      setTimeout(() => {
        if (this.shareData.scrollToTop) {
          msgdiv.scrollTop = 0
        } else {
          msgdiv.scrollTop = msgdiv.scrollHeight
        }
      }, 100)
    },
    sentMessage (msg = '', file = null, msgType) {
      // 发送消息；msg消息文本；file消息文件；msgType消息类型（txt，img，file，audio，video）
      // if(this.shareData.imGroupList.length===0) return
      const vm = this
      const _this = this
      const time = +new Date()
      vm.msgType = msgType
      const id = WebIM.conn.getUniqueId()
      // eslint-disable-next-line new-cap
      const msgObj = new WebIM.message(msgType, id)
      let option = {
        to: this.groupid,
        chatType: 'groupChat',
        ext: {
          nikeName: JSON.parse(localStorage.getItem('user_info')).name,
          avatar: JSON.parse(localStorage.getItem('user_info')).photo
        }
      }
      // console.log('option',option)
      if (msg) option = Object.assign(option, { msg: this.msgText })
      if (file) option = Object.assign(option, { file: file, ext: { ...option.ext, file_length: file.data.size } })
      // console.log(option);
      msgObj.set({
        ...option,
        onFileUploadError: function (error) {
          vm.$message.error('图片上传失败', error)
        },
        onFileUploadComplete: function (data) {
          // console.log(data);
          const url = data.uri + '/' + data.entities[0].uuid
          // console.log('url', url)
          // console.log(file);
          option.msg = url
          if (vm.msgType !== 'txt') {
            const formData = new FormData()
            formData.append('file', file.data)
            formData.append('customDir', 'hytc_ebook_server/file/chatGourp')
            formData.append('access_token', _this.access_token || '')
            axios({
              url: _this.$uploadUrl,
              method: 'post',
              data: formData,
              headers: { 'Content-Type': 'multipart/form-data' }
            }).then((res) => {
              console.log(res)
              if (res && res.data && res.data.url) {
                const message = {
                  ...option,
                  from: vm.userId,
                  type: vm.msgType,
                  msgId: id,
                  filename: file.filename,
                  fileLength: file.data.size,
                  secret: data.entities[0]['share-secret'],
                  url: res.data.url,
                  createDate: time
                }

                // console.log(message);
                vm.saveMsg(message)
                shareState.setMsgList(message)
                vm.recoderVisible = false
              }
            })
          }
        },
        success: function () {
          // 更新消息列表
          // console.log('vm.msgType', vm.msgType === 'txt')
          // window._czc.push(['_trackEvent', '班级群聊', '发送消息', vm.msgType])
          if (vm.msgType === 'txt') {
            const message = {
              ...option,
              from: vm.userId,
              type: vm.msgType,
              msgId: id,
              createDate: time
            }
            // console.log('message', message.time.toString().length, message)
            vm.saveMsg(message)
            shareState.setMsgList(message)

            // vm.$store.commit('setMsgList', message);
            vm.msgText = ''
          }
          vm.scrollTo()
        },
        fail: function (e) {
          vm.$message.error('发送失败！' + e)
        }
      })
      // console.log('msgObj.body', msgObj.body);
      WebIM.conn.send(msgObj.body)
    },
    sendTextMsg () {
      // 发送文本消息
      if (this.msgText === '' || this.msgText === '\n') {
        this.msgText = ''
        this.$message.info('不能发送空消息！')
        return false
      }
      this.sentMessage(this.msgText, null, 'txt')
    },
    selectEmoji (e) {
      // 选择并发送表情消息
      this.msgText = e
      this.sendTextMsg()
    },
    renderTxt (txt = '') {
      // 处理并显示表情符号
      const rnTxt = []
      let match = null
      const regex = /(\[.*?\])/g
      let start = 0
      let index = 0
      while ((match = regex.exec(txt))) {
        index = match.index
        if (index > start) {
          if (txt != null) {
            rnTxt.push(txt.substring(start, index))
          } else {
            rnTxt.push(' ')
          }
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]]
          rnTxt.push(this.customEmoji(v))
        } else {
          rnTxt.push(match[1])
        }
        start = index + match[1].length
      }
      if (txt != null) {
        rnTxt.push(txt.substring(start, txt.length))
      } else {
        rnTxt.push(' ')
      }
      return rnTxt.toString().replace(/,/g, '')
    },
    customEmoji (value) {
      return `<img src="faces/${value}" style="width:30px"/>`
    },
    clickUpload () {
      const upload = this.$refs.uploadDom
      upload && upload.click()
    },
    fileChange (e) {
      console.log(e)
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        // const target = e.target;
        // const file = WebIM.utils.getFileUrl(target);
        // 也可将文件自行处理成该格式。
        // let file = {
        //    data: file              file 对象。
        //    filename: 'fileName',   文件名称。
        //    filetype: 'filetype',   文件类型。
        // }
        const files = []
        for (let i = 0; i < e.target.files.length; i++) {
          const file = {
            data: e.target.files[i],
            filename: e.target.files[i].name,
            filetype: e.target.files[i].type
          }

          if (!file || file.data.size === 0) {
            this.$message.info('不能上传空文件！')
            return false
          }
          if (file.data.size / 1024 / 1024 > 10) {
            this.$message.info('文件大小不能超过10M，请压缩后上传！')
            return false
          }
          files.push(file)
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          const type = getFileType(file.filetype)
          if (type === 'audio' || type === 'video') file.duration = 60
          this.sentMessage('', file, type)
        }
      }
    },
    openRecorder () {
      this.recoderVisible = true
    },
    mouseStart (e) {
      // 长按说话
      e.preventDefault()
      this.startRec()
    },
    mouseEnd (e) {
      // 松开时上传语音
      e.preventDefault()
      this.stopRecorder()
    },
    waving () {
      if (this.isRecording) {
        for (let i = 0; i < this.randomheight.length; i++) {
          this.randomheight[i] = 60 * Math.random().toFixed(2) + 10
        }
        setTimeout(() => {
          this.waving()
        }, 100)
      } else {
        this.randomheight.fill(30)
      }
    },
    startRec () {
      if (!this.recorder) {
        this.recorder = new Recorder(this.recConfig)
        this.isRecording = false
        this.recorder.onprogress = (params) => {
          this.remainingRecTime = this.totalRecTime - parseInt(params.duration)
          if (this.remainingRecTime <= 0) {
            this.$message.info('录音不能超过1分钟！')
            this.recorder.stop()
          }
        }
      }
      if (this.isRecording) {
        this.stopRecorder()
        return
      }
      this.recorder.start().then(
        () => {
          this.isRecording = true
          this.waving()
        },
        (error) => {
          this.$message.error(`${error.name} : ${error.message}`)
        }
      )
    },
    stopRecorder () {
      this.recorder.stop()
      this.isRecording = false
      this.remainingRecTime = this.totalRecTime
      if (this.recorder.fileSize > 0) {
        this.uploadRec()
      }
    },
    uploadRec () {
      const blob = this.recorder.getWAVBlob()
      const url = WebIM.utils.parseDownloadResponse.call(WebIM.conn, blob)
      const file = {
        url,
        filename: 'audio' + new Date(),
        filetype: 'audio/wav',
        data: blob,
        duration: this.remainingRecTime - this.remainingRecTime
      }
      this.sentMessage('', file, getFileType(file.filetype))
    },
    playAudio () {
      // console.log('playAudio--' + message)
      //
      // const audio = document.getElementById('my-audio')
      // const request = new XMLHttpRequest()
      // console.log('playAudio--audio.src--' + message.src)
      // // request.open('Headers', message.src, true)
      // request.open('HEAD', message.src, true)
      // request.onreadystatechange = function () {
      //   if (this.readyState === this.DONE) {
      //     if (this.status === 200) {
      //       // 不需要重定向
      //       console.log('playAudio:redirectedSrc--' + 200)
      //       audio.play()
      //     } else if (this.status === 302 || this.status === 307) {
      //       // 需要重定向
      //       const redirectedSrc = this.getResponseHeader('Location')
      //       console.log('playAudio:redirectedSrc--' + redirectedSrc)
      //       audio.src = redirectedSrc
      //       audio.play()
      //     }
      //   }
      // }
      // request.send()
      console.log('playAudio--')
      this.$nextTick(() => {
        // 获取最新创建的<audio>标签元素
        // const newestAudio = this.$refs.myAudio
        const audios = document.getElementsByTagName('audio')
        const newestAudio = audios[audios.length - 1]
        console.log(newestAudio)
        newestAudio.onloadstart = function () {
          console.log('音频开始加载')
          const xhr = new XMLHttpRequest()
          // xhr.open('GET', newestAudio.src)
          xhr.open('HEAD', newestAudio.src, true)
          xhr.setRequestHeader('Access-Control-Expose-Headers', 'location')
          // xhr.responseType = 'blob'
          xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              const redirectedSrc = this.getResponseHeader('location')
              console.log('playAudio:redirectedSrc--' + redirectedSrc)
              console.log('playAudio:status--' + xhr.status)
              if (xhr.status === 302) {
                // console.log('音频文件返回了302状态码')
                // const redirectedSrc = this.getResponseHeader('Location')
                // console.log('playAudio:redirectedSrc--' + redirectedSrc)
                // newestAudio.src = redirectedSrc
                // audio.play()
              } else {
                console.log('音频文件请求成功')
              }
            }
          }
          xhr.send()
        }
        newestAudio.onloadedmetadata = function () {
          console.log('音频元数据加载完成')
          const xhr = new XMLHttpRequest()
          xhr.open('GET', newestAudio.src)
          xhr.setRequestHeader('Access-Control-Expose-Headers', 'location')
          xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status === 302) {
                console.log('音频文件返回了302状态码')
                const redirectedSrc = this.getResponseHeader('location')
                console.log('playAudio:redirectedSrc--' + redirectedSrc)
                newestAudio.src = redirectedSrc
                // audio.play()
              } else {
                console.log('音频文件请求成功')
              }
            }
          }
          xhr.send()
        }

        newestAudio.onloadeddata = function () {
          console.log('音频数据加载完成')
        }

        newestAudio.oncanplaythrough = function () {
          console.log('浏览器可以完整播放音频')
        }
        console.log('playAudio--' + newestAudio.src)
      })
    }
  }
}
</script>

<style lang="less" scoped>
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;

  .group-title {
    padding: 10px 20px;
    font-size: 18px;
    font-weight: bold;
    height: 50px;

    .tooltips {
      color: #db5647;
      display: inline-block;
      margin-left: 20px;
      cursor: pointer;

      /deep/ .anticon {
        vertical-align: -0.15em;
      }

      .joinClass {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }

  .messages {
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    height: 100%;
    margin-bottom: 100px;
    border: 1px solid #eee;
    overflow: auto;

    .load-more {
      margin-left: auto;
      margin-right: auto;
      width: 150px;
      padding: 3px;
      background-color: #eee;
      border-radius: 10px;
      text-align: center;
      cursor: pointer;
    }

    .message {
      margin: 10px;
      display: flex;
      min-height: fit-content;

      .user-photo {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        margin: 5px;
      }

      .message-body {
        .user-name {
          color: #ccc;
        }

        .message-content {
          border: 1px solid #ddd;
          border-radius: 5px;
          padding: 3px 10px;
          font-size: 14px;
        }

        .message-time {
          color: #ddd;
          margin-top: 5px;
        }
      }
    }

    .right {
      margin-left: auto;
      max-width: 838px;
      word-break: break-all;

      .user-name {
        text-align: right;
      }
    }
  }

  .sent {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 20px;
    height: 100px;
    display: flex;
    flex-direction: column;

    .msg-type-btn {
      font-size: 20px;
      margin: 5px;
      cursor: pointer;
    }

    .sent-content {
      display: flex;
      padding: 10px 0;

      .sengTxt {
        border: none;
        margin-right: 5px;
      }
    }
  }
}

.ant-dropdown-menu {
  display: flex !important;
  flex-wrap: wrap;
  width: 400px !important;
}

.loading {
  position: absolute;
  top: 40%;
  left: 50%;
}

.recoder {
  position: relative;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.15);
  width: 200px;
  height: 200px;
  background: #fff;
}

.sound-waves {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}

.wavesItem {
  border: 1px solid #f2f2f2;
  width: 4px;
  background: green;
  margin: 2px;
}

.remainingRecTime {
  text-align: center;
  font-size: 20px;
}

.tipText {
  text-align: center;
  font-size: 14px;
  position: absolute;
  bottom: 70px;
  width: 100%;
}

.holdBtn {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  text-align: center;
  padding: 0;
  position: absolute;
  bottom: 10px;
  left: calc(50% - 25px);
  background: green;
}

.applyLi {
  height: 120px;

  .applyName {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #040506;

    .userName {
      margin-left: 10px;
      color: @primary-color;
    }

    .name {
      color: #040506;
      margin-left: 10px;
    }

    .className {
      color: #db5647;
      margin-left: 10px;
    }
  }

  .applyFun {
    float: right;

    .sure {
    }

    .refuse {
      margin-left: 20px;
    }
  }
}

.userImg {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
</style>
